import { connect } from "react-redux";
import { DesignChapter } from "@learningblocks/storybook-components";

import { getComponentProps, getOptionsList } from "./Technique.selector";

function mapStateToProps(state, ownProps) {
  return {
    ...getComponentProps(state, ownProps),
    optionsList: getOptionsList(state),
  };
}

function mapDispatchToProps() {
  return {};
}

export const Technique = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.Technique);
